export class VehicleModelConsts {

  static MODEL_CODE = 'modelCode';
  static BRAND_CODE = 'brandCode';
  static PRODUCTION_YEAR = 'productionYear';
  static REGISTRATION_NUMBER = 'registrationNumber';
  static UNKNOWN_REGISTRATION_NUMBER = 'unknownRegistrationNumber';
  static FIRST_REGISTRATION_DATE = 'firstRegistrationDate';

  static FUEL_CODE = 'fuelTypeCode';
  static NUMBER_OF_DOORS = 'numberOfDoors';
  static ENGINE_CAPACITY = 'engineCapacity';

  static VEHICLE_CODE_EUROTAX = 'vehicleCodeEurotax';
  static VEHICLE_CODE_INFOEKSPERT = 'vehicleCodeInfoekspert';

  static TRANSMISSION = 'transmission';
  static ENGINE_POWER = 'enginePower';

}
